/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import LocalizationComponent from '../Library/Scripts/Localization/LocalizationComponent';
import PaylineManager from '../Library/Scripts/Paylines/PaylineManager';
import Bangup from '../Library/Scripts/Playbar/Bangup';
import UserMessageManager from '../Library/Scripts/Playbar/UserMessageManager';
import StateDependencyComponent from '../Library/Scripts/StateManager/StateDependencyComponent';
import StateEvent from '../Library/Scripts/StateManager/StateEvent';
import { StateID } from '../Library/Scripts/StateManager/StateID';
import StateReference from '../Library/Scripts/StateManager/StateReference';
import InjectableComponent from '../Library/Scripts/Utility/Component/ComponentReference/InjectableComponent';
import { ReferenceGroup } from '../Library/Scripts/Utility/Component/ComponentReference/ReferenceGroup';

const {ccclass, property} = cc._decorator;

@ccclass
export default class RedAlertRespin extends StateDependencyComponent
{
    @property({ type: StateReference, visible: true })
    private _startState: StateReference = new StateReference(StateID.Bonus, true, ReferenceGroup.BonusGame_0);

    @property({ type: StateReference, visible: true })
    private _requestState: StateReference = new StateReference(StateID.Request, false, ReferenceGroup.BonusGame_0);

    @property({ type: StateReference, visible: true })
    private _endState: StateReference = new StateReference(StateID.Bonus, true, ReferenceGroup.BonusGame_0);

    /** @hidden */
    private _bangupRef: InjectableComponent<Bangup> = new InjectableComponent();
    /** @hidden */
    private _localRef: InjectableComponent<LocalizationComponent> = new InjectableComponent();
    /** @hidden */
    private _paylineManagerRef: InjectableComponent<PaylineManager> = new InjectableComponent(ReferenceGroup.BonusGame_0);
    /** @hidden */
    private _userMessageRef: InjectableComponent<UserMessageManager> = new InjectableComponent();

    /** @hidden */
    protected start(): void
    {
        super.start([this._startState], [this._requestState], [this._endState]);
    }

    /** @hidden */
    protected setContexts(): void
    {
        this._bangupRef.SetContext(Bangup);
        this._localRef.SetContext(LocalizationComponent);
        this._paylineManagerRef.SetContext(PaylineManager);
        this._userMessageRef.SetContext(UserMessageManager);
    }

    protected onStateChangeHandler = (event: StateEvent): void =>
    {
        if (event.State == this._startState.Value)
        {
            this._bangupRef.Value.IsCumulative = true;
        }
        else if (event.State === this._requestState.Value)
        {
            this._paylineManagerRef.Value.ClearPaylines();
            this.showRespinMessage();
        }
        else if (event.State == this._endState.Value)
        {
            this._bangupRef.Value.IsCumulative = false;
        }
    }

    private showRespinMessage(): void
    {
        this._localRef.WithValue((local) =>
        {
            this._userMessageRef.Value
                .GetViewBuilder()
                    .AddText(local.GetStringResource("Payline/Respin").toUpperCase())
                    .Build();
        }, 
        () =>
        {
            this._userMessageRef.Value
                .GetViewBuilder()
                    .AddText("RESPIN")
                    .Build();
        })
    }
}
